export default __webpack_public_path__ + "static/exarm-zeta-colors-e2d8de0410521c860f0b1462236c0bfe.gif";